import { cn } from '@/lib/utils'

type Props = {
  actual: number
  expected?: number
  className?: string
  mode?: 'planned' | 'resolved'
  setupSize?: number
  ignored?: number
}

const AssignmentExpectedEntitiesCount = ({
  actual,
  expected,
  className,
  mode = 'planned',
  setupSize,
  ignored = 0,
}: Props) => {
  if (typeof expected !== 'number') return null
  const isSuccess =
    mode === 'resolved'
      ? actual + ignored >= expected ||
        (typeof setupSize === 'number' && setupSize < expected)
      : actual <= expected
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 text-sm text-muted-foreground',
        className,
      )}
    >
      <span className='h-1 w-1 rounded-full bg-current opacity-60' />
      <span className='inline-flex items-center gap-0.5'>
        <span
          className={cn(
            'font-medium',
            isSuccess ? 'text-success-foreground' : 'text-warning-foreground',
          )}
        >
          {actual}
        </span>
        <span>/</span>
        <span>{expected}</span>
      </span>
    </span>
  )
}

export default AssignmentExpectedEntitiesCount
